import { Stream } from '@cloudflare/stream-react'
import { Spacing } from '@doordash/design-language'
import * as React from 'react'
import { Placeholder } from './Placeholder'

const ABN_GUIDE_VIDEO_ID = '4b6d8c60020a05e34db450ab8547fa18'

const VideoHeight = {
  Small: 216,
  Large: 416,
}

export function VideoPanel() {
  const [isLoading, setIsLoading] = React.useState(true)
  return (
    <Placeholder
      isLoading={isLoading}
      overflow="hidden"
      borderRadius={Spacing.XxSmall}
      smHeight={VideoHeight.Small}
      lHeight={VideoHeight.Large}
    >
      <Stream
        controls
        width="100%"
        src={ABN_GUIDE_VIDEO_ID}
        onLoadedMetaData={() => setIsLoading(false)}
        height={isLoading ? 'none' : '100%'}
      />
    </Placeholder>
  )
}
